var getFlex = function (flex, basis) {
    if (basis === void 0) { basis = "auto"; }
    if (flex === true) {
        return "1 1 ".concat(basis);
    }
    if (flex === false) {
        return "0 0 ".concat(basis);
    }
    if (flex === "grow") {
        return "1 0 ".concat(basis);
    }
    if (flex === "shrink") {
        return "0 1 ".concat(basis);
    }
    if (typeof flex === "number") {
        return "".concat(flex, " 0 ").concat(basis);
    }
    if (typeof flex !== "object") {
        return "";
    }
    var grow = flex.grow, shrink = flex.shrink;
    return "".concat(grow, " ").concat(shrink, " ").concat(basis);
};
export default (function (_a) {
    var flex = _a.flex, basis = _a.basis;
    if (flex === undefined && basis === undefined) {
        return "";
    }
    if (basis && flex === undefined) {
        return "flex-basis: ".concat(basis, ";");
    }
    var flexValue = getFlex(flex, basis);
    return flexValue ? "flex: ".concat(flexValue, ";") : "";
});
